import { useLanguage } from "../lang/LanguageContext";
import { parseLinks } from "../utils/parseLinks";

export default function MyResearch() {
  const { strings } = useLanguage();
  const textWithLinks = parseLinks(
    strings.research.description,
    strings.research.links
  );

  return (
    <section className="flex flex-col md:flex-row items-center justify-center mt-12 px-6 max-w-4xl mx-auto">
      <div className="text-center">
        <h1 className="text-3xl font-bold">{strings.research.title}</h1>
        <p className="mt-4 text-gray-700 text-justify">{textWithLinks}</p>
      </div>
    </section>
  );
}
